import"./Select.css";import{cn}from"../../utils/bem";export var COMPONENT_NAME="Select";export var cnSelect=cn("Select");
//# sourceMappingURL=cnSelect.js.map